import axios from '@/axios';

const RESOURCE_NAME = '/elastic-ai-conversations';

export default {
    getRecentConversations() {
        return axios.get(`${RESOURCE_NAME}/get-recent-conversations`)
    },

    getConversationData(id) {
        return axios.get(`${RESOURCE_NAME}/get-conversation-data?id=${id}`)
    },

    getAiDiscoveryData(roundId) {
        return axios.get(`${RESOURCE_NAME}/get-ai-discovery-data?round_id=${roundId}`)
    },
}
